import { useMutation, useQueryClient } from '@tanstack/react-query'
import { transitionToNextTier } from 'api/shifts/transitionToNextTier'
import { tierEligibilitiesByShiftIdKey } from './keys'

export const useTransitionToNextTierMutation = (
  listingId: number,
  shiftId: number
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => transitionToNextTier({ listingId }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: tierEligibilitiesByShiftIdKey(shiftId),
      }),
  })
}
